import { CancelToken, ApiRequestConfig } from 'api';
import { get, put } from 'features/api';
import { FetchModels, ViewsModels } from '../types';
import { transformMeasurementSettingsResponse } from '../utils/response-transformers';

export function* fetchMeasurementSettings(
  params: FetchModels.MeasurementSettingsParams,
  options?: ApiRequestConfig,
) {
  const data = (yield* get<ViewsModels.MeasurementSettings>(
    'get-checkout-settings',
    {
      productId: params.productId,
      regionCode: params.regionCode,
      modelId: params.modelId,
      unitOfsale: params.unitOfsale,
    },
    {
      ...options,
    },
  )) as unknown;

  return transformMeasurementSettingsResponse(data as FetchModels.MeasurementSettingsResponse);
}

export function setBasket({ products, regionCode }: FetchModels.SetBasketParams, cancelToken: CancelToken) {
  return put(
    'set-basket',
    {
      products,
      regionCode,
    },
    {
      cancelToken,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    },
  );
}
